export * from './SlideLeft';
export * from './SlideRight';

const DURATION = 300;

export const TransitionDuration = {
  milliseconds: DURATION,
  seconds: DURATION / 1000,
};
